import { useMutation } from '@tanstack/react-query';
import { useInvalidateFilesQueries } from '@/api/hooks/useInvalidateFileQueries';
import Toast from '@trinity/chat-components/components/Toast/index.js';
import type { DeleteFileParams } from '../interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';

export const useDeleteFileMutation = () => {

  const invalidateFileQueries = useInvalidateFilesQueries();
  const apiClient = useChatApiClient();

  const mutation = useMutation({
    mutationFn: (data: DeleteFileParams) => {
      return apiClient.workspaces.deleteFile({
        fileId: data.fileId,
        workspaceId: data.workspaceId,
      });
    },
    onError: (error) => {
      Toast.error({
        title: 'Error',
        body: `We're sorry, there was an issue with your request: ${error.message}`,
      });
    },
    onSuccess: (data) => {
      Toast.alert({
        title: 'File Deleted',
      });
      invalidateFileQueries();
      return data;
    },
  });
  return mutation;
};

export default useDeleteFileMutation;